export function delete_row() {
  // Delete rows
  $('body').on('click', '.delete-row', function() {
    $(this).closest('.grid-x').remove();
  });

  $('body').on('click', '.delete', function() {
    $(this).closest('.field-row').remove();
  });
}